module.exports = __webpack_public_path__ + "37d5fb7979d88f4cb11db0d8ed919939.pdf";